<script>
import { markRaw } from 'vue';

import MixinList from '@/Libs/Mixins/ListTab.js';

import StuffSidebar from '@/Libs/Pages/Panel/Config/General/Part/StuffSidebar.vue';

export default {
    mixins: [MixinList],
    data() {
        return {
            stuffSidebar: markRaw(StuffSidebar),

            routeName: 'config-general',
            tabName: 'stuff'
        };
    },
    methods: {
        async _search(search) {
            return await this.$api.ConfigStuff.all(search);
        },
        // ======
        async onRefresh() {
            await this._doSearch();
        },
    }
};
</script>

<template>
    <BRow>
        <BCol lg="12">
            <BCard no-body>
                <BCardBody>
                    <div>
                        <div class="table-responsive table-card position-relative">
                            <loading :loading="$loading.get([routeName, tabName, 'list'].join('_'))" variant="dark" type="block">
                                <table class="table align-middle table-hover table-nowrap mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                            <th>{{ $t('config_general.label.stuff_type') }}</th>
                                            <th>{{ $t('config_general.label.value') }}</th>
                                            <th style="width: 150px;">{{ $t('basic.label.action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in list" :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ tr.name }}
                                                <span class="badge bg-danger-subtle text-danger"
                                                    v-if="tr.is_static == 1">{{
                                                        $t('stuff.label.static')
                                                    }}</span>
                                            </td>
                                            <td>{{ tr.value }}</td>
                                            <td>
                                                <btn-sidebar variant="warning" v-model="list[index]"
                                                    v-if="($ac.hasAccess('config_general_create'))"
                                                    :sidebar="stuffSidebar" :success="onRefresh">
                                                    <i class="mdi mdi-pencil-outline align-bottom me-1"></i> {{
                                                        $t('basic.btn.edit') }}
                                                </btn-sidebar>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </loading>
                        </div>
                    </div>
                </BCardBody>
            </BCard>
        </BCol>
    </BRow>
    <BRow class="mb-3">
        <BCol>
            <div>
                <pagination v-bind:model="paginator" v-on:goto="goto"
                    :disabled="$loading.get([routeName, 'list'].join('_'))" />
            </div>
        </BCol>
    </BRow>
</template>